/* Monttco — cor/tamanho/adicionar-à-sacola on each "Todas as Peças" card.
   Real Shopify variants: matches the selected color+size option values
   against the product's own variants (embedded as JSON per card) to find
   a real variant id, then reuses Dawn's own add-to-cart mechanism
   (assets/product-form.js's pattern) so the existing cart drawer, its
   count bubble and its section-rendering all keep working unmodified. */
(function(){
  "use strict";

  function getCart(){
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  function addToCart(variantId, button){
    var cart = getCart();
    var body = new FormData();
    body.append('id', variantId);
    body.append('quantity', '1');
    if (cart && cart.getSectionsToRender){
      body.append('sections', cart.getSectionsToRender().map(function(s){ return s.id; }));
      body.append('sections_url', window.location.pathname);
    }
    var original = button.textContent;
    button.disabled = true;
    button.textContent = 'Adicionando…';
    fetch(window.routes ? window.routes.cart_add_url : '/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    })
      .then(function(r){ return r.json(); })
      .then(function(response){
        if (response.status){
          button.textContent = 'Não foi possível adicionar';
          setTimeout(function(){ button.textContent = original; button.disabled = false; }, 1500);
          return;
        }
        button.textContent = 'Adicionado à sacola';
        button.classList.add('is-added');
        if (cart && cart.renderContents) cart.renderContents(response);
        if (cart && cart.open) cart.open();
        document.dispatchEvent(new CustomEvent('monttco:cart-changed', { detail: { open: true } }));
        setTimeout(function(){
          button.textContent = original;
          button.classList.remove('is-added');
          button.disabled = false;
        }, 1200);
      })
      .catch(function(){
        button.textContent = 'Não foi possível adicionar';
        setTimeout(function(){ button.textContent = original; button.disabled = false; }, 1500);
      });
  }

  document.querySelectorAll('#allPiecesGrid .fd-item').forEach(function(card){
    var variantsScript = card.querySelector('[data-role="variants"]');
    var variants = [];
    try { variants = JSON.parse(variantsScript.textContent); } catch (e){}
    var colorIdx = parseInt(card.getAttribute('data-color-index'), 10);
    var sizeIdx = parseInt(card.getAttribute('data-size-index'), 10);
    var state = { color: null, size: null };

    var colorBtns = card.querySelectorAll('.ap-color-btn');
    var activeColorBtn = card.querySelector('.ap-color-btn.is-active');
    if (activeColorBtn) state.color = activeColorBtn.getAttribute('data-value');

    function findVariant(){
      return variants.filter(function(v){
        var okColor = colorIdx < 0 || !state.color || v.options[colorIdx] === state.color;
        var okSize = sizeIdx < 0 || !state.size || v.options[sizeIdx] === state.size;
        return okColor && okSize;
      })[0];
    }

    function syncImageForColor(){
      if (colorIdx < 0 || !state.color) return;
      var match = variants.filter(function(v){ return v.options[colorIdx] === state.color && v.featured_image; })[0];
      if (!match || !match.featured_image) return;
      var front = card.querySelector('[data-role="front"]');
      if (front) front.src = match.featured_image.src.replace(/(\.[a-z]+)(\?|$)/i, '_900x$1$2');
    }

    colorBtns.forEach(function(btn){
      btn.addEventListener('click', function(){
        colorBtns.forEach(function(b){ b.classList.remove('is-active'); b.setAttribute('aria-pressed', 'false'); });
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');
        state.color = btn.getAttribute('data-value');
        syncImageForColor();
        var href = card.querySelector('.fd-name-link').getAttribute('href').split('?')[0];
        var v = findVariant();
        if (v) card.querySelectorAll('.fd-media-link, .fd-name-link').forEach(function(a){ a.href = href + '?variant=' + v.id; });
      });
    });

    var sizeBtns = card.querySelectorAll('.ap-size-btn');
    var addBtn = card.querySelector('[data-role="add-btn"]');
    sizeBtns.forEach(function(btn){
      btn.addEventListener('click', function(){
        sizeBtns.forEach(function(b){ b.classList.remove('is-active'); b.setAttribute('aria-pressed', 'false'); });
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');
        state.size = btn.getAttribute('data-value');
        hideMsg();
        syncAddBtn();
      });
    });

    var sizeMsg = card.querySelector('[data-role="size-msg"]');
    var sizesWrap = card.querySelector('.ap-sizes');
    var msgTimer;
    function hideMsg(){
      if (sizeMsg){ sizeMsg.textContent = ''; sizeMsg.classList.remove('is-visible'); }
      if (sizesWrap) sizesWrap.classList.remove('is-pulse');
    }
    function askForSize(){
      if (sizeMsg){ sizeMsg.textContent = 'Escolha seu tamanho'; sizeMsg.classList.add('is-visible'); }
      if (sizesWrap){
        sizesWrap.classList.remove('is-pulse');
        void sizesWrap.offsetWidth; /* restart animation */
        sizesWrap.classList.add('is-pulse');
      }
      clearTimeout(msgTimer);
      msgTimer = setTimeout(hideMsg, 3000);
    }
    /* Botão "Comprar" sempre clicável; só fica "Esgotado" se a variante escolhida (ou o produto todo) estiver indisponível. */
    function syncAddBtn(){
      if (!addBtn) return;
      var anyAvailable = variants.some(function(v){ return v.available; });
      var v = findVariant();
      var soldOut = variants.length ? (!anyAvailable || (state.size && (!v || !v.available))) : false;
      addBtn.disabled = !!soldOut;
      addBtn.textContent = soldOut ? 'Esgotado' : 'Comprar';
    }

    if (addBtn){
      addBtn.addEventListener('click', function(){
        if (sizeBtns.length && !state.size){ askForSize(); return; }
        var v = findVariant();
        if (!v || !v.available) return;
        addToCart(v.id, addBtn);
      });
      colorBtns.forEach(function(b){ b.addEventListener('click', syncAddBtn); });
      syncAddBtn();
    }
  });
})();
